/* eslint-disable no-prototype-builtins */
class HaversineGeolocation {
  /**
   * Convert measurements: "km to mi" or "km to m"
   *
   * @param distance
   * @param measurement
   * @returns {*}
   */
  _convertMeasurements(distance, measurement = 'km') {
    let res = null

    switch (measurement.toLowerCase()) {
      case 'mi':
        res = (distance * 0.62137).toFixed(1)
        break
      case 'km':
        res = distance.toFixed(1)
        break
      case 'm':
        res = (distance * 1000).toFixed()
        break
      default:
        res = distance.toFixed(1)
    }

    return parseInt(res)
  }

  /**
   * Get distance between positions by Haversine formula
   *
   * @param args
   * @return {number}
   */
  _haversine(...args) {
    const rad = args.map((deg) => (deg / 180.0) * Math.PI)
      const lat1 = rad[0]
      const lon1 = rad[1]
      const lat2 = rad[2]
      const lon2 = rad[3]
      const R = 6372.8
      const dLat = lat2 - lat1
      const dLon = lon2 - lon1
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) *
          Math.sin(dLon / 2) *
          Math.cos(lat1) *
          Math.cos(lat2)
      const c = 2 * Math.asin(Math.sqrt(a))

    return R * c
  }

  /**
   * Check if geolocation enabled in user browser and users current position coordinates
   *
   * @return {Promise}
   */
  isGeolocationAvailable() {
    return new Promise((resolve, reject) => {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (data) => {
            resolve(data)
            // eslint-disable-next-line no-debugger
            // debugger
          },
          (error) => {
            switch (error.code) {
              case error.PERMISSION_DENIED:
                reject(new Error('Error: Permission denied'))
                break
              case error.POSITION_UNAVAILABLE:
                reject(new Error('Error: Position unavailable'))
                break
              case error.TIMEOUT:
                reject(new Error('Error: Timeout'))
                break
            }
          }
        )
      } else {
        reject(new Error('Error: Geolocation disabled in your browser'))
      }
    })
  }

  /**
   * Calculate distance between two positions
   *
   * @param p1
   * @param p2
   * @param measurement
   * @returns {number}
   */
  getDistanceBetween(p1, p2, measurement) {
    if (
      p1.hasOwnProperty('latitude') &&
      p1.hasOwnProperty('longitude') &&
      p2.hasOwnProperty('latitude') &&
      p2.hasOwnProperty('longitude')
    ) {
      const d = this._haversine(
        p1.latitude,
        p1.longitude,
        p2.latitude,
        p2.longitude
      )

      return this._convertMeasurements(d, measurement)
    } else {
      throw new Error('Error: Position latitude or longitude is not correct')
    }
  }

  /**
   * Get closest position from array of positions
   *
   * @param current
   * @param otherPoints
   * @param measurement
   * @returns {{}}
   */
  getClosestPosition(current, otherPoints, measurement) {
    let distance = null
    const data = {}

    otherPoints.map((position) => {
      const res = this.getDistanceBetween(current, position, measurement)
      if (distance === null || distance > res) {
        distance = res
        for (const prop in position) {
          if (position.hasOwnProperty(prop)) {
            data[prop] = position[prop]
          }
        }
        data.haversine = { distance, measurement, accuracy: current.accuracy }
      }
    })

    return data
  }
}

export default new HaversineGeolocation()
